// The fleet list's reads beyond the fleet store. docs/features/peek.md.

import { apiFetchAuthed } from '../apiHelpers';
import type { DroneLog } from './types';

/** Every uploaded flight log for one drone, newest upload first. */
export const getDroneLogs = (serial: string): Promise<DroneLog[]> =>
  apiFetchAuthed(`/logs/drone/${encodeURIComponent(serial)}`, { silent: true });
